import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8x24y4789g: FaireBrandEntity = {
  token: "b_8x24y4789g",
  type: "brand",
  name: "Mycrazycrystal",
  avatarUrl:
    "https://cdn.faire.com/fastly/9dcd1be826dde04e4398fd72b610ce9a3b99d0471954bd2b0ace972aa7f200e7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/332dd6177d70ffc6c3d5880ac10feac4893dc7d715bbbcacad566a270dc01e5a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9dcd1be826dde04e4398fd72b610ce9a3b99d0471954bd2b0ace972aa7f200e7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/332dd6177d70ffc6c3d5880ac10feac4893dc7d715bbbcacad566a270dc01e5a.jpeg",
  location: "Henderson, NV, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "Mycrazycrystal is a wholesale gemstone business, offering a wide range of quality crystals and gemstones including beads, DIY materials, pendants, gemstone trees, and more. Our commitment to excellence ensures that we source and made the gemstones globally to meet the needs of jewelry makers, decorators, and enthusiasts. Explore the beauty of nature's gemstones with Mycrazycrystal.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:27.870Z",
    importedBy: "entity-db-cli",
  },
};
